import data from "../data";
import columns from "./tableColumns";
import { Spin, Table } from "antd";
import { usePaginationPrzekazy } from "../../../context/PaginationContextPrzekazy";
import { useState } from "react";
import SearchInput from "./search";
import GenerateXML from "./GenerateXML";
import formatPrice from "../../../components/formatPrice";

const PrzekazyTable = () => {
	const { pagination, setPagination } = usePaginationPrzekazy();
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [selectedRowsByKey, setSelectedRowsByKey] = useState({});

	const normalizeKey = (key) => String(key);

	const handleRowClick = (record) => {
		if (!record.msr_przekazania_generated_files_id) {
			setSelectedRowKeys((prevSelectedKeys) => {
				const recordKey = normalizeKey(record.key);
				const prevKeysNormalized = prevSelectedKeys.map(normalizeKey);
				if (prevKeysNormalized.includes(recordKey)) {
					setSelectedRowsByKey((prev) => {
						const next = { ...prev };
						delete next[recordKey];
						return next;
					});
					return prevSelectedKeys.filter(
						(key) => normalizeKey(key) !== recordKey,
					);
				} else {
					setSelectedRowsByKey((prev) => ({
						...prev,
						[recordKey]: record,
					}));
					return [...prevSelectedKeys, record.key];
				}
			});
		}
	};

	const onSelectChange = (selectedKeys, selectedRows) => {
		setSelectedRowKeys(selectedKeys);
		setSelectedRowsByKey((prev) => {
			const next = {};
			selectedKeys.forEach((key) => {
				const normalized = normalizeKey(key);
				if (prev[normalized]) next[normalized] = prev[normalized];
			});
			(selectedRows || []).forEach((row) => {
				next[normalizeKey(row.key)] = row;
			});
			return next;
		});
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		getCheckboxProps: (record) => ({
			disabled: !!record.msr_przekazania_generated_files_id,
		}),
	};

	const handleTableChange = (paginationInfo) => {
		const { current, pageSize } = paginationInfo;
		setPagination((prev) => ({
			...prev,
			current,
			pagesize: pageSize,
		}));
	};

	const rows = data();

	const selectedCount = selectedRowKeys.length;
	const selectedTotal = selectedRowKeys.reduce((sum, key) => {
		const row = selectedRowsByKey[normalizeKey(key)];
		const amount = parseFloat(row?.msr_przekazania_amount || 0);
		return sum + (Number.isFinite(amount) ? amount : 0);
	}, 0);

	return (
		<>
			<div
				className="table-header"
				style={{
					display: "flex",
					alignItems: "center",
					gap: "10px",
					marginBottom: "16px",
					padding: "20px",
					paddingBottom: "0",
				}}
			>
				<SearchInput />
				{selectedCount > 0 && (
					<div
						style={{
							alignSelf: "center",
							whiteSpace: "nowrap",
							padding: "0 8px",
						}}
					>
						Zaznaczone: <b>{selectedCount}</b> | Suma:{" "}
						<b>{formatPrice(selectedTotal)} zł</b>
					</div>
				)}
				<GenerateXML
					ids={selectedRowKeys}
					selectedRows={selectedRowKeys
						.map((key) => selectedRowsByKey[normalizeKey(key)])
						.filter(Boolean)}
					setSelectedRowKeys={setSelectedRowKeys}
				/>
			</div>
			<div
				className="table-body"
				style={{ padding: "20px", paddingTop: "0" }}
			>
				<Spin spinning={pagination.loading}>
					<Table
						rowSelection={rowSelection}
						columns={columns}
						onChange={handleTableChange}
						dataSource={rows.data}
						loading={pagination.loading}
						expandIcon={false}
						rowClassName={(record) =>
							Number(record?.msr_wplywy_to_forward_ready || 0) ===
							1
								? "przekaz-row-ready"
								: "przekaz-row-not-ready"
						}
						pagination={{
							current: pagination.current,
							pageSize: pagination.pagesize,
							total: rows.total,
							showSizeChanger: true,
							pageSizeOptions: ["1", "10", "20", "50", "100"],
						}}
						onRow={(record) => ({
							style:
								Number(
									record?.msr_wplywy_to_forward_ready || 0,
								) === 1
									? {
											background: "#f6ffed",
											borderLeft: "4px solid #52c41a",
										}
									: {
											background: "#fffaf0",
											borderLeft: "4px solid #faad14",
										},
							onClick: () => handleRowClick(record),
						})}
					/>
				</Spin>
			</div>
		</>
	);
};

export default PrzekazyTable;
